import { BrowserRouter, useSearchParams } from "react-router-dom"
import ProjectLayout from "@common/general/ProjectLayout"
import { useEffect } from "react"
import { useProjectDataStore } from "@state/projectDataStore"
import PayloadLivePreview from "@utils/PayloadLivePreview"
import { useStore } from "@state/store"
import { parseTSV } from "@data/parseTsv"
import { useFavoritesStore } from "@state/favouritesStore"
import { getUnitsURL, isWailsEnvironment } from "@utils/wailsUtils"

function App() {
  const syncState = useStore((s) => s.syncState)
  const { clearFavorites } = useFavoritesStore((state) => state)
  const { selectedPhase } = useStore((state) => state)
  let structuredData

  useEffect(() => {
    const fetchData = async () => {
      try {
        let response
        let urlToUse = import.meta.env.VITE_GOOGLE_SHEETS_URL

        // If environment variable is not set, try to get URL from Wails config
        if (!urlToUse && isWailsEnvironment()) {
          try {
            urlToUse = await getUnitsURL()
            console.log("Using URL from Wails config:", urlToUse)
          } catch (error) {
            console.error("Failed to get URL from Wails config:", error)
          }
        }

        if (!urlToUse) {
          console.error(
            "No URL available - neither from environment variable nor from Wails config",
          )
          return
        }

        try {
          response = await fetch(urlToUse)
          if (!response.ok) {
            throw new Error(`Server responded with status ${response.status}`)
          }
        } catch (fetchError) {
          console.error("Fetch error:", fetchError)

          const cachedData = localStorage.getItem("availabilityData")
          if (cachedData) {
            const parsedCache = JSON.parse(cachedData)

            if (
              parsedCache &&
              typeof parsedCache === "object" &&
              Array.isArray(parsedCache.phase1) &&
              Array.isArray(parsedCache.phase2)
            ) {
              syncState({
                availabilityData: parsedCache,
              })

              return
            }
          }

          return
        }

        const data = await response.text()
        const parsed = parseTSV(data).filter(
          (item) => item.status === "Available",
        )

        const phase1 = parsed.filter((item) => item.phase === "one")
        const phase2 = parsed.filter((item) => item.phase === "two")

        console.log(parsed, phase2)
        structuredData = { phase1, phase2 }

        localStorage.setItem("availabilityData", JSON.stringify(structuredData))

        // console.log(structuredData[selectedPhase])

        syncState({
          availabilityData: structuredData[selectedPhase],
        })
      } catch (error) {
        console.error("Unexpected error:", error)
      }
    }

    fetchData()
    clearFavorites()
  }, [selectedPhase])

  // useEffect(() => {
  //   syncState({
  //     availabilityData: structuredData[selectedPhase],
  //   })
  // }, [selectedPhase])

  return (
    <BrowserRouter>
      <ProjectWrapper />
    </BrowserRouter>
  )
}

export default App

function ProjectWrapper() {
  const { livePreview, setLocalState } = useProjectDataStore((s) => ({
    livePreview: s.livePreview,
    setLocalState: s.setLocalState,
  }))

  const [searchParams] = useSearchParams()

  useEffect(() => {
    const openNavParam = searchParams.get("livePreview")
    if (openNavParam !== null) {
      setLocalState({ livePreview: true })
    }
  }, [searchParams])

  return (
    <>
      <ProjectLayout />
      {livePreview && <PayloadLivePreview />}
    </>
  )
}
